<template>
  <div
    @wheel.passive="manageWheel"
    class="spa-body bg-deepWater inset-0 grid w-screen h-screen overflow-hidden"
  >
    <div
      class="lg:relative main-wrapper lg:overflow-visible grid w-full min-h-0 overflow-hidden"
    >
      <div class="lg:container lg:mx-auto flex min-h-0">
        <div class="lg:block flex-1 hidden" />
        <transition name="fade" mode="out-in">
          <div
            v-if="isDesktop || prevPage"
            class="lg:bg-transparent inset-x-0 top-0 flex flex-col items-center flex-1 h-auto pb-2"
            :class="{ 'cursor-pointer': prevPage }"
            @click="debouncedNavigate(-1)"
          >
            <transition name="fade" mode="out-in">
              <svg
                v-if="prevPage"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="hover-hover:hover:text-brand hover-hover:hover:bg-accent active:text-primary active:bg-white w-8 h-8 rounded-full"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 15l7-7 7 7"
                />
              </svg>
            </transition>
            <transition v-if="isDesktop" name="fade" mode="out-in">
              <span
                :key="prevPage"
                v-text="prevPage ? prevPage.meta.label || 'Continua' : ''"
              />
            </transition>
          </div>
        </transition>
        <div class=" lg:flex justify-end flex-1 hidden">
          <app-cta-button
            class="w-min whitespace-nowrap"
            external
            :link="apriContoUrl"
            button-style="brand"
          />
          <app-cta-button
            class=" w-min whitespace-nowrap"
            :text="'Area Clienti'"
            :link="areaClientiLink"
            external
            button-style="brand"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="inline-block w-4 h-4 mr-1 fill-current"
            >
              <path
                d="M18.8 9H18V6A6 6 0 006 6v3h-.8C4 9 3 10 3 11.3v10.4C3 23 4 24 5.3 24h13.4c1.3 0 2.3-1 2.3-2.3V11.3C21 10 20 9 18.7 9zM8 6a4 4 0 018 0v3H8zm5 10.7V19a1 1 0 11-2 0v-2.3a2 2 0 011-3.7 2 2 0 011 3.7z"
              />
            </svg>
          </app-cta-button>
        </div>
      </div>
      <div :class="dynamicClasses">
        <div
          class="lg:h-full lg:min-h-0 container relative flex-1 w-full mx-auto"
        >
          <router-view v-slot="{ Component }">
            <transition
              @enter="scrollTop"
              :name="transitionName"
              :mode="isDesktop ? undefined : 'out-in'"
            >
              <component :is="Component" />
            </transition>
          </router-view>
        </div>
      </div>
      <div class="min-h-0">
        <transition name="fade" mode="out-in">
          <div
            v-if="isDesktop || nextPage"
            class="inset-x-0 bottom-0 flex flex-col items-center h-auto pt-2 cursor-pointer"
            :class="{ 'cursor-pointer': nextPage }"
            @click="debouncedNavigate(1)"
          >
            <transition v-if="isDesktop" name="fade" mode="out-in">
              <span
                :key="nextPage"
                v-text="nextPage ? nextPage.meta.label || 'Indietro' : ''"
              />
            </transition>
            <transition @name="fade" mode="out-in">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="hover-hover:hover:text-brand hover-hover:hover:bg-accent active:text-primary active:bg-white w-8 h-8 rounded-full"
                v-if="nextPage"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </transition>
          </div>
        </transition>
      </div>
    </div>
    <div class="bg-deepWater lg:bg-transparent z-10">
      <MainNav class="flex-none" :area-clienti-link="areaClientiLink" />
    </div>
    <!-- <cookie /> -->
  </div>
</template>

<script>
import MainNav from "@/components/nav/MainNav.vue";
import _ from "lodash";
import Cookie from "@/components/cookie.vue";

export default {
  components: { MainNav, Cookie },
  computed: {
    areaClientiLink() {
      return process.env.VUE_APP_AREA_CLIENTI;
    },
    viewportHeight() {
      return window.innerHeight;
    },
    transitionName() {
      return `slide${this.$route.meta.scrolling}`;
    },
    nextPage() {
      return this.getAdjacentRoute(1);
    },
    prevPage() {
      return this.getAdjacentRoute(-1);
    },
    isHelp() {
      return this.$route.name === "Help" ? true : false;
    },
    dynamicClasses() {
      console.log(this.isHelp);
      return {
        "overflow-y-hidden": this.isHelp,
        "lg:overflow-visible flex flex-col items-center h-full min-h-0 p-4 overflow-x-hidden": true
      };
    }
  },
  created() {
    this.debouncedNavigate = _.debounce(this.navigate, 1250, {
      leading: true,
      trailing: false,
      maxWait: 2000
    });
  },
  methods: {
    getAdjacentRoute(direction) {
      const routes = _.filter(
        this.$router.getRoutes(),
        r => !_.get(r.meta, "hideMenu.main")
      );
      if (direction > 0) {
        return _.find(
          _.orderBy(routes, "meta.order"),
          r => r.meta && r.meta.order >= this.$route.meta.order + direction
        );
      }
      return _.find(
        _.orderBy(routes, "meta.order", ["desc"]),
        r => r.meta && r.meta.order <= this.$route.meta.order + direction
      );
    },
    navigate(direction) {
      const route = this.getAdjacentRoute(direction);
      route && this.$router.push(route);
    },
    manageWheel(event) {
      const direction = event.deltaY < 1 ? -1 : 1;
      if (this.isDesktop) {
        this.debouncedNavigate(direction);
      }
    }
  }
};
</script>
<style scoped>
.spa-body {
  @apply bg-cover bg-center bg-no-repeat;
  background-image: url("/assets/Desktop/IBL_Sito_ControCorrente_Sfondo_Pagine.jpg");
  grid-template-rows: auto min-content;
}
.main-wrapper {
  grid-template-rows: min-content auto min-content;
}
</style>

<style></style>
